import $store from '../store'
// import VueCookies from 'vue-cookies'

import {_getAccessToken, _resetAuthData, _getRefreshToken, _parseAccessToken, _setAuthData} from '../services/utils'


//check does user have accessToken and refreshToken
export async function checkAccessMiddleware(to, from, next) {
  const accessToken = _getAccessToken()
  const refreshToken = _getRefreshToken()
  const isAuthRoute = to.matched.some(item => item.meta.isAuth)
  if (isAuthRoute && accessToken && refreshToken)
    return next()
  if (isAuthRoute && (!accessToken || !refreshToken)) {
    await _resetAuthData(false)
    return next({path: `auth/login`})
  }
  next()
}

// check is user accessToken valid
export async function checkAuth(to, from, next) {

  const accessToken = _getAccessToken()
  const refreshToken = _getRefreshToken()
  const userId = $store.state.main.user.id

  if (accessToken && refreshToken && (from.name === 'login' || !userId)) {
    // call user services and get user info
    try {
      const user = await $store.dispatch('main/crud', {
        action: 'get',
        section: 'profile',
      })
      const result = user.data
      if (result) {
        await _setAuthData({accessToken: accessToken, refreshToken: refreshToken})
        await $store.commit('main/APPEND', {key: 'user', value: result})
      }
    } catch (error) {
      console.log(error)
    }
    return next()
  }
  if (!accessToken && !refreshToken && userId) {
    await _resetAuthData(false)
    return next({path: 'auth/login'})
  }
  next()
}

export function checkPreventLogeIn(to, from, next) {
  const accessToken = _getAccessToken()
  const refreshToken = _getRefreshToken()
  const isLoggedInPrevented = to.matched.some(item => item.meta.preventLoggedIn)
  if (accessToken && refreshToken && isLoggedInPrevented)
    return next({path: ''})
  next()
}


export function setPageTitleMiddleware(to, from, next) {

  // this is just for dynamic_pages which have prefix in route params
  let prefix
  if (to.params.prefix)
    prefix = String(to.params.prefix)
  else
    prefix = null
  // console.log(to)
  const nearestWithTitle = () => {
    if (to.matched.slice().reverse().find(r => r.meta && r.meta.title))
      return to.matched.slice().reverse().find(r => r.meta && r.meta.title).meta.title
    else if (to.matched.slice().reverse().find(r => r.meta && r.meta.pages))
      if (to.meta.pages[prefix] !== undefined)
        return to.matched.slice().reverse().find(r => r.meta && r.meta.pages).meta.pages[prefix].title
      else
        return false
  }
  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle()) {

    document.title = nearestWithTitle()
  }
  next()
}

export function enable_loading(to, from, next,) {
  // console.log('set loading true')

  $store.commit('main/SET', {key: 'loading', value: true})
  next()
}

export function disable_loading(to, from) {
  // console.log('set loading false')
  setTimeout(() => $store.commit('main/SET', {key: 'loading', value: false}), 700)

}
